import { z } from 'zod';

import { bookingSchema } from './Booking.ts';

export const placeSchema = z.object({
  id: z.number(),
  order: z.number(),
  node: z.number(),
  index: z.number(),
  name: z.string(),
  type: z.string(),
  status: z.string(),
  min_time: z.string().optional().nullable(),
  max_time: z.string().optional().nullable(),
  arrival_time: z.string(),
  departure_time: z.string(),
  updated_at: z.string(),
  bookings: z.array(bookingSchema),
});

export type Place = z.infer<typeof placeSchema>;
